<template>
  <div class="shop-detail">
    <div class="top-bar mb-4">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <p class="subtitle">Mesas y Barra</p>
          </div>
        </div>
        <div class="level-right" v-if="isShopOpen">
          <!-- <div class="level-item">
            <p>Total en Caja {{ currency(cash) }}</p>
          </div> -->
          <div class="level-item">
            <button @click="toggleBillPayment" class="button is-warning">
              <span class="material-symbols-outlined"> hail</span>
              Pago Proveedores
            </button>
          </div>
          <div class="level-item">
            <button @click="toggleWitdrawal" class="button is-danger">
              <span class="material-symbols-outlined"> request_quote</span>
              Retiro
            </button>
          </div>
          <div class="level-item">
            <button @click="toggleShopClose" class="button is-success">
              <span class="material-symbols-outlined">
                account_balance_wallet
              </span>
              Cerrar Caja
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="withdrawal box has-background-grey-lighter"
      v-if="showWitdrawal && isShopOpen"
    >
      <div class="columns is-vcentered">
        <div class="column">
          <p class="title">Ingrese la cantidad a retirar</p>
        </div>
        <div class="column is-quarter">
          <div class="field">
            <div class="control has-icons-left">
              <input
                type="number"
                pattern="[0-9]*"
                class="input is-large has-text-right"
                :class="{
                  'is-danger':
                    withdrawalAmmount > cash || withdrawalAmmount < 0,
                }"
                v-model="withdrawalAmmount"
                :max="cash"
                step="50"
                min="0"
                placeholder="0"
                id="withdrawal-input"
              />
              <span class="icon is-left">
                <span class="material-symbols-outlined">attach_money</span>
              </span>
            </div>
          </div>
        </div>
        <div class="column is-quarter">
          <div class="field">
            <div class="control has-icons-left">
              <input
                type="text"
                class="input is-large"
                placeholder="Describa el retiro"
                v-model="withdrawalText"
                name="withdrawal-text"
                id="withdrawal-text-input"
              />
              <span class="icon is-left">
                <span class="material-symbols-outlined">edit</span>
              </span>
            </div>
          </div>
        </div>
        <div class="column is-narrow">
          <button
            class="control button is-large is-primary"
            @click="withdrawal()"
          >
            Retirar
          </button>
        </div>
        <div class="column is-narrow">
          <button
            class="delete"
            aria-label="close"
            @click="toggleWitdrawal"
          ></button>
        </div>
      </div>
    </div>
    <div
      class="bill-payment box has-background-grey-lighter"
      v-if="showBillPayment && isShopOpen"
    >
      <div class="columns is-vcentered">
        <div class="column">
          <p class="title">Ingrese el valor a pagar</p>
        </div>
        <div class="column is-quarter">
          <div class="field">
            <div class="control has-icons-left">
              <input
                type="number"
                pattern="[0-9]*"
                class="input is-large has-text-right"
                :class="{
                  'is-danger':
                    billPaymentAmmount > cash || billPaymentAmmount < 0,
                }"
                placeholder="0"
                v-model="billPaymentAmmount"
                :max="cash"
                step="50"
                min="0"
                name="bill-payment"
                id="bill-payment-input"
              />
              <span class="icon is-left">
                <span class="material-symbols-outlined">attach_money</span>
              </span>
            </div>
          </div>
        </div>
        <div class="column is-quarter">
          <div class="field">
            <div class="control has-icons-left">
              <input
                type="text"
                class="input is-large"
                placeholder="Describa el pago"
                v-model="billPaymentText"
                name="bill-payment-text"
                id="bill-payment-text-input"
              />
              <span class="icon is-left">
                <span class="material-symbols-outlined">edit</span>
              </span>
            </div>
          </div>
        </div>
        <div class="column is-narrow">
          <button
            class="control button is-large is-primary"
            @click="billPayment()"
          >
            Pagar
          </button>
        </div>
        <div class="column is-narrow">
          <button
            class="delete"
            aria-label="close"
            @click="toggleBillPayment"
          ></button>
        </div>
      </div>
    </div>
    <div
      class="close-shop box has-background-grey-lighter"
      v-if="isShopOpen && showCloseShop"
    >
      <div class="level">
        <div class="level-item">
          <p class="title">
            Ingrese el dinero en caja para el realizar el cierre!
          </p>
        </div>
        <div class="level-item">
          <div class="field">
            <div class="control has-icons-left has-addons">
              <input
                type="number"
                pattern="[0-9]*"
                class="input is-large has-text-right autofocus"
                v-model="closeCash"
                min="0"
                placeholder="0"
                required
              />
              <span class="icon is-left">
                <span class="material-symbols-outlined">attach_money</span>
              </span>
              <p class="help">Ingrese el efectivo en caja.</p>
            </div>
          </div>
        </div>
        <div class="level-item">
          <button class="button is-large is-primary" @click="closeShop">
            Cerrar
          </button>
        </div>
      </div>
    </div>
    <div class="open-shop box has-background-grey-lighter" v-if="!isShopOpen">
      <div class="level">
        <div class="level-item">
          <p class="title">Es necesario abrir caja!</p>
        </div>
        <div class="level-item">
          <div class="field">
            <div class="control has-icons-left has-addons">
              <input
                type="number"
                pattern="[0-9]*"
                class="input is-large has-text-right autofocus"
                v-model="baseCash"
                @keyup.enter="openShop"
                placeholder="0"
              />
              <span class="icon is-left">
                <span class="material-symbols-outlined">attach_money</span>
              </span>
              <p class="help">Ingrese la base</p>
            </div>
          </div>
        </div>
        <div class="level-item">
          <button class="button is-large is-primary" @click="openShop">
            Abrir
          </button>
        </div>
      </div>
    </div>
    <div class="columns is-mobile is-multiline is-centered" v-else>
      <div
        class="column is-half-mobile is-one-quarter-tablet is-2-desktop"
        v-for="table in tables"
        v-bind:key="table.id"
      >
        <table-bucket
          :table="table"
          @check-bill="addCash"
          @taken-table="takeTable"
          @print-receipt="printReceipt"
          :id="table.id"
        ></table-bucket>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import TableBucket from "@/components/TableBucket";
import * as bulmaToast from "bulma-toast";

export default {
  name: "ShopDetailView",
  data() {
    return {
      shop_id: null,
      shop_name: "",
      shop_slug: "",
      isShopOpen: false,
      tables: [],
      takenTables: 0,
      availableTables: 0,
      cash: 0,
      baseCash: 0,
      closeCash: 0,
      withdrawalAmmount: 0,
      withdrawalTotal: 0,
      withdrawalText: "",
      showWitdrawal: false,
      showBillPayment: false,
      showCloseShop: false,
      showPrintReceipt: false,
      billPaymentAmmount: 0,
      billPaymentTotal: 0,
      billPaymentText: "",
    };
  },
  components: {
    TableBucket,
  },
  beforeMount() {
    // get_current_shop_status
    if (localStorage.getItem("isShopOpen")) {
      this.isShopOpen = JSON.parse(localStorage.getItem("isShopOpen"));
    }
    this.shop_slug = this.$route.params.shop_slug;
    this.getDetail();
  },
  mounted() {
    this.getTables();
    document.title = this.$store.getters.getShop.name || "Coffee Shop Admin";
  },
  methods: {
    takeTable() {
      this.takenTables++;
      this.availableTables--;
    },
    async getDetail() {
      console.log("getDetail");
      await axios
        .get(`/api/v1/shop/${this.shop_slug}`)
        .then((response) => {
          this.shop_id = response.data.id;
          this.shop_name = response.data.name;
          this.shop_slug = response.data.slug;
          console.log(response.data);
          this.$store.commit("setShop", response.data);
          this.getShopStatus();
        })
        .catch((error) => {
          console.log("Error obteniendo detalle de Tienda.");
          console.log(error);
          if (error.response.status == 401) {
            console.log("Error Autenticación");
            this.removeCredentials();
          }
          if (error.response.status == 500) {
            console.log("Error Tienda no encontrada");
            this.$router.push({ name: "not-found" });
          }
        });
    },
    async getShopStatus() {
      await axios
        .get(`/api/v1/shop/${this.shop_slug}/status`)
        .then((response) => {
          switch (response.data.type) {
            case "base":
              this.baseCash = parseFloat(response.data.total || 0);
              this.withdrawalTotal = parseFloat(response.data.withdrawals || 0);
              this.billPaymentTotal = parseFloat(response.data.payments || 0);
              this.cash =
                this.baseCash +
                parseFloat(response.data.sales || 0) -
                this.withdrawalTotal -
                this.billPaymentTotal;
              // Set shop Open
              this.isShopOpen = true;
              localStorage.setItem("isShopOpen", true);
              break;
            case "cierre":
              this.baseCash = 0;
              this.cash = 0;
              this.isShopOpen = false;
              localStorage.setItem("isShopOpen", false);
              break;
          }
        })
        .catch((error) => {
          console.log("Error obteniendo listado de mesas.");
          console.log(error);
        });
    },
    async openShop() {
      const formData = {
        shop: this.shop_id,
        type: "base",
        total: this.baseCash,
      };
      await axios
        .post(`/api/v1/shop/${this.shop_slug}/cash-operations/`, formData)
        .then((response) => {
          this.cash = response.data.total;
          this.isShopOpen = true;
          localStorage.setItem("isShopOpen", true);
        })
        .catch((error) => {
          console.log("Error abriendo la caja.");
          console.log(error);
          this.isShopOpen = false;
          localStorage.setItem("isShopOpen", false);
        });
    },
    async getTables() {
      await axios
        .get(`/api/v1/shop/${this.shop_slug}/tables`)
        .then((response) => {
          this.tables = response.data;
          this.takenTables = this.tables.filter((t) => t.last_status[0]).length;
          this.availableTables = this.tables.length - this.takenTables;
          // this.updateTableStatus();
        })
        .catch((error) => {
          console.log("Error obteniendo listado de mesas.");
          console.log(error);
          if (error.response.status == 401) {
            console.log("Error Autenticación");
            this.removeCredentials();
          }
        });
    },
    addCash(amomunt) {
      this.cash += amomunt.due;
      this.availableTables++;
      this.takenTables--;
    },
    currency(val) {
      let cur = Intl.NumberFormat("es-CO");
      return `$ ${cur.format(val)}`;
    },
    async closeShop() {
      if (!Number.isFinite(this.closeCash)) {
        bulmaToast.toast({
          message:
            "No es posible hacer el retiro porque no se ha ingresado un valor",
          type: "is-danger",
          position: "bottom-right",
        });
        return;
      }
      if (
        !confirm(
          `¿Está seguro de cerrar la caja con ${this.currency(this.closeCash)}?`
        )
      ) {
        return;
      }
      let diffcash = this.closeCash - this.cash;
      let closeMsg = "Cierre con cuadre OK!";
      if (diffcash != 0) {
        closeMsg = `Cierre con descuadre de ${this.currency(diffcash)}`;
      }

      const formData = {
        shop: this.shop_id,
        type: "cierre",
        total: this.closeCash,
        description: closeMsg,
      };
      await axios
        .post(
          `/api/v1/shop/${this.$store.getters.getShop.slug}/cash-operations/`,
          formData
        )
        .then(() => {
          this.baseCash = 0;
          this.cash = 0;
          this.isShopOpen = false;
          localStorage.setItem("isShopOpen", false);
          this.toggleShopClose();
        })
        .catch((error) => {
          console.log("Error cerrando la caja.");
          console.log(error);
        });
    },
    async withdrawal() {
      if (this.cash < this.withdrawalAmmount || this.withdrawalAmmount == 0) {
        bulmaToast.toast({
          message:
            "No es posible hacer el retiro porque la cantidad no es mayor a 0, o no hay saldo suficiente para el retiro",
          type: "is-danger",
          position: "bottom-right",
        });
        return;
      }
      const formData = {
        shop: this.shop_id,
        type: "retiro",
        total: this.withdrawalAmmount,
        description:
          this.withdrawalText ||
          "Retiro de " + this.currency(this.withdrawalAmmount),
      };
      await axios
        .post(`/api/v1/shop/${this.shop_slug}/cash-operations/`, formData)
        .then((response) => {
          bulmaToast.toast({
            message: "Retiro OK",
            type: "is-success",
            position: "bottom-right",
          });
          let withdrawalbase = parseFloat(response.data.total || 0);
          this.cash -= withdrawalbase;
          this.withdrawalTotal += withdrawalbase;
          this.withdrawalAmmount = 0;
          this.withdrawalText = null;
          this.toggleWitdrawal();
        })
        .catch((error) => {
          console.log("Error realizando el retiro");
          console.log(error);
        });
    },
    toggleWitdrawal() {
      if (this.withdrawalAmmount == 0) {
        this.withdrawalAmmount = "";
      }
      this.showWitdrawal = !this.showWitdrawal;
    },
    async billPayment() {
      console.log(this.billPaymentAmmount);
      if (this.cash < this.billPaymentAmmount || this.billPaymentAmmount == 0) {
        bulmaToast.toast({
          message:
            "No es posible realizar el pago, revise que la cantidad sea mayor a 0 o que tenga suficiente en caja.",
          type: "is-danger",
          position: "bottom-right",
        });
        return;
      }
      const formData = {
        shop: this.shop_id,
        type: "pago",
        total: this.billPaymentAmmount,
        description:
          this.billPaymentText ||
          "Pago de proveedor " + this.currency(this.billPaymentAmmount),
      };
      await axios
        .post(`/api/v1/shop/${this.shop_slug}/cash-operations/`, formData)
        .then((response) => {
          bulmaToast.toast({
            message: "Pago OK",
            type: "is-success",
            position: "bottom-right",
          });
          let paymentBase = parseFloat(response.data.total || 0);
          this.cash -= paymentBase;
          this.billPaymentTotal += paymentBase;
          this.billPaymentAmmount = 0;
          this.billPaymentText = null;
          this.toggleBillPayment();
        })
        .catch((error) => {
          console.log("Error realizando el pago.");
          console.log(error);
        });
    },
    toggleBillPayment() {
      if (this.billPaymentAmmount == 0) {
        this.billPaymentAmmount = "";
      }
      this.showBillPayment = !this.showBillPayment;
    },
    toggleShopClose() {
      this.closeCash = "";
      if (this.showCloseShop) {
        this.showCloseShop = !this.showCloseShop;
        return;
      }
      // check all tables are closed
      if (this.takenTables > 0) {
        console.log("No es posible cerrar la caja, aún hay mesas abiertas");
        bulmaToast.toast({
          message: "No es posible cerrar la caja, aún hay mesas abiertas",
          type: "is-danger",
          position: "bottom-right",
          dismissible: true,
        });
        return;
      }
      this.showCloseShop = !this.showCloseShop;
    },
    removeCredentials() {
      axios.defaults.headers.common["Authorization"] = "";
      this.$store.commit("removeToken");
      this.$router.push("/log-in");
    },
    printReceipt() {
      this.showPrintReceipt = !this.showPrintReceipt;
    },
    // updateTableStatus() {
    //   console.log("UpdateTableStatus");
    //   this.takenTables = this.$store.getters.getShop.tables.filter(
    //     (t) => t.last_status[0]
    //   ).length;
    //   console.log(this.takenTables);
    //   this.availableTables =
    //     this.$store.getters.getShop.tables.length - this.takenTables;
    //   console.log(this.availableTables);
    // },
  },
};
</script>
